<button
  class="h-full w-full"
  [class.cursor-not-allowed]="disabled"
  type="button"
  (click)="buttonClick()"
>
  <ng-content></ng-content>
</button>
